import { DateTime } from "luxon"

import type { IntervalGranularity } from "./interval-data-selection"

const AS_GIVEN_DATE_FORMAT = "yyyy-MM-dd"
const AS_GIVEN_TIME_FORMAT = "HH:mm"
const ISO_BUCKET_FORMAT: Record<IntervalGranularity, string> = {
  as_given: "yyyy-MM-dd HH:mm",
  day: "yyyy-MM-dd",
  month: "yyyy-MM",
  year: "yyyy",
}

const bucketDateTime = (value: string, timeZone?: string | null): DateTime =>
  timeZone
    ? DateTime.fromISO(value, { zone: timeZone })
    : DateTime.fromISO(value, { setZone: true })

export const formatIntervalBucketLabel = (
  granularity: IntervalGranularity,
  value: string,
  timeZone?: string | null
): string => {
  const dateTime = bucketDateTime(value, timeZone)
  if (!dateTime.isValid) {
    return value
  }

  return dateTime.toFormat(ISO_BUCKET_FORMAT[granularity])
}

// As-given axis labels are two lines, HH:mm then yyyy-MM-dd, on every tick.
// The chart keeps the date on the first visible tick of each site-local day,
// including when that tick is not midnight. Other granularities stay on one
// line. The tooltip keeps formatIntervalBucketLabel.
export const formatIntervalAxisTickLabel = (
  granularity: IntervalGranularity,
  value: string,
  timeZone?: string | null
): string => {
  if (granularity !== "as_given") {
    return formatIntervalBucketLabel(granularity, value, timeZone)
  }

  const dateTime = bucketDateTime(value, timeZone)
  if (!dateTime.isValid) {
    return value
  }

  return `${dateTime.toFormat(AS_GIVEN_TIME_FORMAT)}\n${dateTime.toFormat(AS_GIVEN_DATE_FORMAT)}`
}
